export default __webpack_public_path__ + "static/media/exit.5811c21b.svg";